export default __webpack_public_path__ + "static/media/30daycalendar.2f26b1fd.webp";